<style src="./InsertItems.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="insert-items">
    <div
      class="drop-zone"
      @dragover="isDragOver"
      @dragenter="isDragOver"
      @dragleave="isDragLeave"
      @dragend="isDragLeave"
      @drop="isDrop"
      :class="{'drop-zone-over': dragOverClass}">
      <label class="input-label">
        <input
          type="file"
          class="input-file"
          accept=".csv"
          @change="isChoosed">

        <icon-upload class="icon"/>
        <h3>Respositório dos Itens</h3>
        <h5>Arraste os MODELO aqui ou clique para escolher</h5>
      </label>
    </div>

    <button
      class="btn btn-primary"
      @click="openBidMirror">
      Ir para Associação de Itens
    </button>
  </section>
</template>

<script>
import { IconUpload } from '@/components/primitives/icons'
import FileHandle from './FileHandle'

export default {
  name: 'Analyse',
  components: {
    IconUpload
  },
  props: {
    eventId: null
  },
  data () {
    return {
      dragOverClass: false,
      uploadStage: 'UPLOAD'
    }
  },
  methods: {
    openBidMirror () {
      this.$store.dispatch('Events/OPEN_EVENT_TO_ASSOCIATE_ITEMS', { eventId: this.eventId, route: this.$router })
    },
    isDragOver (e) {
      e.preventDefault()
      e.stopPropagation()

      if (!this.dragOverClass) this.dragOverClass = true
    },
    isDragLeave (e) {
      e.preventDefault()
      e.stopPropagation()

      if (this.dragOverClass) this.dragOverClass = false
    },
    isDrop (e) {
      e.preventDefault()
      e.stopPropagation()
      if (this.dragOverClass) this.dragOverClass = false
      this.uploadItems(e.dataTransfer.files[0])
    },
    isChoosed (e) {
      e.preventDefault()
      e.stopPropagation()
      this.uploadItems(e.target.files[0])
    },
    async uploadItems (file) {
      try {
        await FileHandle({
          eventId: this.eventId,
          file
        })

        this.$toasted.success('itens salvo com sucesso')
      } catch (error) {
        this.$toasted.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/event/insert-items/InsertItems.vue